import { MediaData } from '@noammazuz/vzn-media';
import * as moment from 'moment';

export interface SiteField {
    title: string;
    placeholder: string;
}

export interface MenuItem {
    title: string;
    link: string;
}
export class Site {
    _id: string;
    name: string;
    title: string;
    dateTitle: string;
    dates: Date[];
    logo: MediaData;
    bgImage: MediaData;
    contentImage: MediaData;
    siteTitle: string;
    formTitle: string;
    submitButtonLabel: string;
    siteId: string;
    maillistId: string;
    rightsMessage: string;
    confirmationMessage: string;
    userNameTitle: string;
    passwordTitle: string;
    userNamePlaceholder: string;
    passwordPlaceholder: string;
    active: boolean;
    selectionField: boolean;
    direction: 'rtl' | 'ltr';
    selectionFieldType: 'radio' | 'select';
    selectionFieldPlaceholder: string;
    selectionFieldErrorMessage: string;
    selectionFieldTitle: string;
    selectionFieldOptions: string[];
    backgroundColor: string;
    fontColor: string;
    themeColor: string;
    additionalFields: SiteField[];
    headerMenuItems: MenuItem[];
    formPosition: string;
    logoLink: string;
    logoPosition: string;
    savePasswords: boolean;
    footerLogoPosition: string;
    favicon: MediaData;
    spaceLogoAndItems: boolean;

    constructor(data) {
        Object.assign(this, data);

        this.backgroundColor = data.backgroundColor || '#ffffff';
        this.fontColor = data.fontColor || '#000000';

        this.dates = this.dates.map((date: any) => date ? moment(date).toDate() : null );
    }

    get previewLink() {
        return `${window.location.origin}/${this._id}`
    }

    get date1() {
        return this.dates[0];
    }

    get date2() {
        return this.dates[1];
    }

    get date3() {
        return this.dates[2];
    }
}
